/* eslint-disable eag/match-named-export, eag/no-index -- Pre-existing grab-bag file with several exports. Pre-existing violation */
import {CurrencyCodeType} from 'shared/web';

import {DocumentRestrictionFormType} from './types';

export const emptyRestrictionItem = (currency: CurrencyCodeType): DocumentRestrictionFormType => ({
  amount: {
    amount: '',
    currency,
  },
  documentTypes: [],
  type: 'off',
  validFrom: null,
});
